import {Loader} from '@/components/atoms'
import {MediaSlotItem} from './MediaSlotItem'
import './productMediaGallery.scss'
import {DragDropProvider} from '@dnd-kit/react'

/**
 * ProductMediaGallery component for managing up to 3 product images
 * Displays a 3-column grid with FileUpload components.
 *
 * @param {Object} props - Component props
 * @param {Array} props.mediaSlots - Current media slots state
 * @param {boolean} props.isUploading - Uploading state
 * @param {Function} props.handleUpload - Upload handler
 * @param {Function} props.handleUploadError - Upload error handler
 * @param {Function} props.handleDeleteImage - Delete image handler
 * @param {string} [props.mediaText] - Optional label for the media section
 * @returns {JSX.Element} The rendered ProductMediaGallery component
 */
export const ProductMediaGallery = ({
  mediaSlots = [],
  isUploading = false,
  handleUpload,
  handleUploadError,
  handleDeleteImage,
  handleDeleteFromServer,
  handleReorder,
  mediaText = 'Product Media',
}) => {
  if (isUploading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader />
      </div>
    )
  }
  return (
    <div className="product-media-gallery product-review-media flex flex-col gap-6">
      <div>
        <h2 className="mb-2 text-lg font-bold">{mediaText}</h2>
      </div>
      <DragDropProvider onDragEnd={handleReorder}>
        <div className="grid grid-cols-3 gap-4">
          {mediaSlots.map(slot => (
            <MediaSlotItem
              key={slot.slotId || `slot-${slot.displayOrder}`}
              slot={slot}
              isUploading={isUploading}
              handleUpload={handleUpload}
              handleUploadError={handleUploadError}
              handleDeleteImage={handleDeleteImage}
              handleDeleteFromServer={handleDeleteFromServer}
            />
          ))}
        </div>
      </DragDropProvider>
    </div>
  )
}
